import React from "react";
import ReactRouterPropTypes from "react-router-prop-types";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import qs from "qs";

const removeEmpty = obj => {
  const newObj = {};
  Object.keys(obj).forEach(key => {
    if (obj[key] && typeof obj[key] === "object") {
      newObj[key] = removeEmpty(obj[key]); // recurse
    } else if (obj[key] != null) {
      newObj[key] = obj[key]; // copy value
    }
  });
  return newObj;
};

const Query = ({
  history,
  location,
  match,
  onClick,
  staticContext,
  search,
  ...rest
}) => {
  const { pathname } = location;
  const current = qs.parse(location.search.substr(1));
  const next = removeEmpty({
    ...current,
    ...search
  });
  const to = `${pathname}?${qs.stringify(next)}`;

  return (
    <button
      type="button"
      {...rest}
      onClick={event => {
        if (onClick) {
          onClick(event);
        }
        history.push(to);
      }}
    />
  );
};

Query.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  location: ReactRouterPropTypes.location.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
  onClick: PropTypes.func,
  search: PropTypes.shape({
    sort: PropTypes.string,
    filter: PropTypes.object
  }).isRequired,
  children: PropTypes.node.isRequired,
  staticContext: PropTypes.shape({})
};

Query.defaultProps = {
  onClick: null,
  staticContext: null
};

export default withRouter(Query);
